export const LABELS = {
  confirmations: {
    deleteEditHistoryTitle: 'Are you sure you want to delete this revision from the history?',
    deleteEditHistoryContent: 'This edit’s content will no longer be visible. This action can not be undone.',
    deleteEditHistoryConfirmButtonContent: 'Remove',
  },
  editHistory: {
    viewingEditTitle: 'Viewing edit',
    deleted: 'Deleted',
    mostRecent: 'Most recent',
    emptyEdit: 'This revision does not contain any content.',
    deletedThisRevision: 'deleted this revision',
    created: 'created',
    edited: 'edited',
    deleteRevisionAriaLabel: 'Delete this edit revision',
    ariaLabel: 'Open edits',
    openEditsButton: 'Edits',
    editedBy: 'Last edited by',
  },
}
